import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { IntegrationInviteDao } from '../../../core/services/dao/integrationInviteDao';
import { ActivatedRoute } from '@angular/router';
import { SharedIntegrationsComponent } from '../../shared/integrations/shared-integrations.component';
import {IntegrationInvite} from "../../../core/models/integrationInvite";
import {TraaqrTag} from "../../../core/models/traaqrTag";

@Component({
  selector: 'app-connect-integrations',
  templateUrl: './connect-integrations.component.html',
  styleUrls: ['./connect-integrations.component.scss']
})
export class ConnectIntegrationsComponent implements OnInit, OnDestroy, AfterViewInit {
  brandName = '';
  advertiser = {};
  agency = {};
  brand = { integrations: [] };
  availableIntegrations = [];
  isPending = true;
  anonInvite: IntegrationInvite;
  brandTag: TraaqrTag;

  @ViewChild(SharedIntegrationsComponent)
  private sharedIntegrationComponent: SharedIntegrationsComponent;

  private subs: Array<Subscription> = [];

  constructor(private integrationInviteDao: IntegrationInviteDao, public activatedRoute: ActivatedRoute) {
    window.localStorage.setItem('inviteToken', this.activatedRoute.snapshot.params.token);
  }

  ngAfterViewInit(): void {
    let sub = this.integrationInviteDao.getInvite(this.activatedRoute.snapshot.params.token).subscribe(
        (res) => {
        let invite = res ? res.invite : null;
        let tag = res ? res.tag : null;
        if (invite && invite.status === 'pending') {
          //Don't remove this set timeout it delays the changes to the next cycle so the change detector
          //picks it up since after view init runs after the change detector runs.
          setTimeout(() => {
            this.brandName = invite.brand.name;
            this.advertiser = invite.advertiser;
            this.brand = invite.brand;
            this.availableIntegrations = invite.integrations;
            this.anonInvite = invite;
            this.brandTag = tag;
            this.sharedIntegrationComponent.init();
          });
        } else {
          this.isPending = false;
        }
      },
      err => {
        console.error(err);
      }
    );
    this.subs.push(sub);
  }

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.subs.forEach(sub => sub.unsubscribe());
  }
}
